import { defineComponent, SVGAttributes } from "vue";

  export const SvgAirplane = defineComponent<SVGAttributes>({
    setup() {
      return () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14.00269,15.4331,12.46731,4.73537l3.004-3.00874S16.27239.52314,15.87185.122c-.33378-.3343-1.60213.40117-1.60213.40117L11.199,3.59873.5848,1.99407l-.6008.60175L8.462,6.34,4.32312,10.4854l-3.07076-.20059L.18427,11.42145l2.47.66861C2.25369,13.42727,2.454,13.561,2.454,13.561h0s.20027.20059,1.46863-.20058l.66755,2.47385L5.725,14.76449l-.20027-3.0756L9.66357,7.54352l3.73832,8.49132Z"/></svg>;
    },
  });